<footer class="footer-area bg-fbf9f8">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <div class="logo">
                        <a routerLink="/"><img src="assets/img/AM_Media_title_logo.png" style="width: 235px;"
                                alt="image"></a>
                    </div>
                    <p>Welcome to AM Media and Sports Pvt Ltd—where media and sports come together to inspire, educate,
                        and empower communities through innovative storytelling and dynamic sporting experiences.</p>
                    <ul class="social-links">
                        <li><a href="https://www.facebook.com/people/A-M-Media-and-Sports/61575779366522/"
                                target="_blank"><i class="icofont-facebook"></i></a></li>
                        <li><a href="https://x.com/ammediasports"><i class="icofont-x"></i></a></li>
                        <li><a href="https://www.instagram.com/ammediasports/"><i class="icofont-instagram"></i></a>
                        </li>
                        <li><a href="https://www.linkedin.com/company/am-media-and-sports-pvt-ltd"><i
                                    class="icofont-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>What We Do</h3>
                    <ul class="services-list">
                        <li><a href="/about">Media & Filmmaking</a></li>
                        <li><a href="/about">Expanding Content Creation</a></li>
                        <li><a href="/about">Post-Production & Outsourcing</a></li>
                        <li><a href="/about">Inclusive Sports Initiatives</a></li>
                        <li><a href="/about">Empowerment Through Opportunity</a></li>
                        <li><a href="/about">Leadership with a Purpose</a></li>
                        <li><a href="/about">Join the Movement</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Usefull links</h3>
                    <ul class="usefull-links">
                        <li><a href="/about">About Us</a></li>
                        <li><a href="/media-service">Services</a></li>
                        <li><a href="#course">Course</a></li>
                        <li><a href="/contact">Contact Us</a></li>
                        <li><a href="#blog">Blog</a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Contacts</h3>
                    <ul class="contact-list">
                        <li><span>Website:</span> <a routerLink="/">ammediasports.com</a></li>
                        <li><span>Email:</span> <a
                                href="mailto:info&#64;ammediasports.com">info&#64;ammediasports.com</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="copyright-area">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>© AM Media & Sports</p>
                </div>

                <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>

<div class="go-top"><i class="icofont-stylish-up"></i></div>